export const AFFINITY_PREFIX = "c";
